import React, { useEffect, useState, useRef } from "react";
import { FaTrash, FaCheck } from "react-icons/fa";
import { getApiCall, postApiCall } from "../../../service/httpCall";
import {API_NOTIFICATION_DELETE} from "../../../service/url";
import { Loader } from "lucide-react";

const AgentNotificationPopup = ({ show, onHide, setHasUnread, position ,notifications, setNotifications,isLoading}) => {
  const localUpdatesRef = useRef({}); // store read/delete updates
  const popupRef = useRef(null); // Ref for the popup container

  useEffect(() => {
    if (!show) return;

    // Close the popup when clicking outside
    const handleClickOutside = (e) => {
      if (popupRef.current && !popupRef.current.contains(e.target)) {
        onHide(); 
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside); // Cleanup the event listener
    };
  }, [show, onHide]);


  const markAsRead = (id) => {
  const readIds = JSON.parse(localStorage.getItem('read_notification_ids') || '[]');
     if (!readIds.includes(id)) {
        readIds.push(id);
        localStorage.setItem('read_notification_ids', JSON.stringify(readIds));
  }

    setNotifications((prev) =>{
    const updated = prev.map((n) => (n.id === id ? { ...n, is_read: true } : n));
    return updated;
  });
};
  

 const deleteNotification = async (id) => {
  try {
    await postApiCall(API_NOTIFICATION_DELETE.replace(':id', id));
    
    const readIds = JSON.parse(localStorage.getItem('read_notification_ids') || '[]');
    const filteredIds = readIds.filter(itemId => itemId !== id);
    localStorage.setItem('read_notification_ids', JSON.stringify(filteredIds));

    setNotifications((prev) => prev.filter((n) => n.id !== id));
  } catch (err) {
    console.error(err);
  }
};

 const markAllRead = () => {
  const allIds = notifications.map(n => n.id);
  localStorage.setItem('read_notification_ids', JSON.stringify(allIds));

  setNotifications((prev) => prev.map((n) => ({ ...n, is_read: true })));
  setHasUnread(false);
};


  // Helper function to format the time (created_at)
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleString(); // Change this format as per your needs
  };

  return (
    show && (
      <div
        ref={popupRef} // Attach the ref to the popup container
        style={{
          position: "absolute",
          top: `${position.top + 30}px`,
          left: `${position.left - 700}px`,
          zIndex: 1050,
          width: "300px",
          background: "white",
          borderRadius: "8px",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
          padding: "10px",
          maxHeight: "400px",
          overflowY: "auto",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            borderBottom: "1px solid #ddd",
            paddingBottom: "10px",
            marginBottom: "10px",
          }}
        >
          <div style={{ fontWeight: "bold" }}>Notifications</div>
          <FaCheck
            title="Mark all as read"
            style={{ cursor: "pointer" }}
            onClick={markAllRead}
          />
        </div>

    {isLoading ? (
    <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
        <Loader className="animate-spin" /> 
    </div>
    ) :
        notifications
         .filter((n) => {
          return n.is_general === true && n.is_deleted === false;
       })
        .length === 0 ? (
      <p style={{ textAlign: "center", padding: "10px", color: "#666" }}>
        No notifications
      </p>

        ) : (
          notifications
           .filter((n) => n.is_general === true && n.is_deleted === false)
            .map((n) =>(
            <div
              key={n.id}
              style={{
                padding: "10px",
                marginBottom: "10px",
                borderRadius: "8px",
                // background: n.is_read ? "rgb(245, 245, 245)" : "rgb(255, 255, 255)",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                border: n.is_read ? "1px solid #00b10f" : "1px solid red",
              }}
            >
              <div
                onClick={() => {
                  if (!n.is_read) {
                    markAsRead(n.id);
                  }
                }}
                style={{ cursor: n.is_read ? "default" : "pointer", flex: 1, minWidth: 0, marginRight: "10px" }}
              >
                <div
                  style={{
                    fontWeight: "bold", // Title in bold
                    fontSize: "14px",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    marginBottom: "4px"
                  }}
                >
                  {n.notification_type} {/* Title */}
                </div>
                <div
                  style={{
                    fontSize: "12px",
                    // color: "#555",
                    wordBreak: "break-word",
                    whiteSpace: "normal",
                    lineHeight: "1.4",
                  }}
                >
                  {n.description} {/* Description */}
                  <br />
                  <small style={{ color: "#999", display: "block", marginTop: "5px" }}>
                    {formatDate(n.created_at)} {/* Time */}
                  </small>
                </div>
              </div>

              {/* Icons Section */}
               <div style={{ display: "flex", gap: "10px", alignItems: "center", flexShrink: 0}}>
      
     
              {!n.is_read && (
              <FaCheck
              title="Mark as read"
              style={{ cursor: "pointer", color: "green", fontSize: "14px" }}
              onClick={(e) => {
              e.stopPropagation(); 
               markAsRead(n.id);
          }}
        />
      )}
     
              {/* <FaTrash
              title="Delete notification"
              style={{ cursor: "pointer", color: "red", fontSize: "14px" }}
              onClick={(e) => {
              e.stopPropagation(); 
              deleteNotification(n.id);
        }}
      /> */}
            </div>
             </div>
          ))
        )}
      </div>
    )
  );
};

export default AgentNotificationPopup;